import React from 'react';
import { Modal, Spin, Row, Col, Upload, message } from 'antd';
import PropTypes from 'prop-types';
import { ResumeUploadIcon } from '../../../components/common/CustomIcon';
import { allowedTypes } from '../../../constants/resumeFileType';

function UploadResumeModal (props) {
  const { loading, profileService } = props;
  const { uploadResumeFile = [] } = profileService.state;
  const handleBeforeUpload = (file) => {
    if (allowedTypes.includes(file.type)) {
      profileService.setState({ uploadResumeFile: [file] });
      return false;
    } else {
      // Handle file type error on frontend also
      message.error('This file type is not allowed');
    }
  };

  return (
    <Modal
      className="turing-ui-v2-modal"
      title="Upload Resume"
      okText="Save"
      width={700}
      {...props}
      okButtonProps={{
        disabled: !uploadResumeFile || !uploadResumeFile.length
      }}
    >
      <Spin spinning={loading}>
        <Row gutter={[12, 0]}>
          <Col span={24}>
            <p>
              Upload your resume below and we&apos;ll try to automatically parse
              your information for the next steps. Don&apos;t worry if your
              resume isn&apos;t perfect, we&apos;ll help you polish it later.
            </p>
            <Upload.Dragger
              accept=".pdf, .doc, .docx, application/msword"
              beforeUpload={handleBeforeUpload}
              fileList={uploadResumeFile}
              multiple={false}
              disabled={loading}
              onRemove={(e) =>
                profileService.setState({ uploadResumeFile: [] })
              }
            >
              <p className="ant-upload-drag-icon">
                <ResumeUploadIcon />
              </p>
              <p className="ant-upload-text">Drag and drop</p>
              <p className="ant-upload-hint">
                your file here, or{' '}
                <span style={{ color: '#56A8F7' }}>browse</span>
              </p>
            </Upload.Dragger>
            <small>Max. file size: 4MB (.pdf or .doc files only)</small>
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
}

UploadResumeModal.propTypes = {
  loading: PropTypes.bool,
  profileService: PropTypes.object
};

export default UploadResumeModal;
